import type { UserType } from "@/app/store";
import type {
	CatalogContentBlock,
	ConsultantViewContentBlock
} from "@/domain/catalog";

/**
 * Client-side visibility gate for the "For Consultants" accordion: returns
 * the `consultant_view_content` selling-tips HTML only for a logged-in
 * consultant, `undefined` otherwise. The block ships in the shared Algolia
 * projection for every viewer, so visibility is decided here, per-user, off
 * the hydrated user store — never during server render (see
 * `docs/caching-strategy.md`).
 */
export function resolveConsultantSellingTips(
	blocks: CatalogContentBlock[] | undefined,
	userType: UserType
): string | undefined {
	if (userType !== "consultant") return undefined;
	const block = blocks?.find(
		(b): b is ConsultantViewContentBlock =>
			b.blockType === "consultant_view_content"
	);
	return block?.selling_tips || undefined;
}
